import React from 'react';
import { useTranslation } from 'react-i18next';
import { Image, QuickLink } from '@honda-canada/design-system-react';

const MenuItemWithExternalLink = ({ item }) => {
  const { t } = useTranslation();

  if (!item) return null;

  const { ctaLink = {}, icon = {}, label } = item;
  const { href } = ctaLink;
  const { src, alt } = icon;

  return (
    <QuickLink
      title={t(label)}
      href={href}
      variantName="primary"
      layout="noPadding"
      icon={
        <Image
          data-testid="cy-user-icon"
          src={src}
          alt={alt}
          style={{
            width: '19px',
            height: '19px',
            marginTop: '6px',
            marginLeft: '16px',
          }}
        />
      }
      data-testid="mobile-nav-item-linkout"
      showExternalIcon
      style={{
        lineHeight: '18px',
        fontFamily: 'default',
        paddingLeft: '8px',
      }}
    />
  );
};

export default MenuItemWithExternalLink;
